import { defineComponent } from 'vue'
import { ecosystemMemberHasAccessToChallenge } from '@/util/helpers'

export default defineComponent({
  data () {
    return {}
  },
  computed: {
    profile () {
      return this.$store.state.user.profile
    },
    isLoggedIn (): boolean {
      return this.$store.getters.isLoggedIn
    },
    userId (): Number {
      return Number(this.$store.getters.userId)
    },
    isEcosystemMember (): boolean {
      return this.$store.getters.isActor
    },
    isPortfolioMember (): boolean {
      return this.$store.getters.isPortfolioMember
    },
    isMember (): boolean {
      return this.$store.getters.isMember
    },
    isOwner (): boolean {
      return this.$store.getters.isOwner
    },
    isDeveloper () {
      return this.$store.getters.isDeveloper
    },
    isUserOfDataScoutsTeam () {
      return this.$store.getters.isUserOfDataScoutsTeam
    },
    claimedActors () {
      return this.profile.claims
    },
    canUserAccessChallengeDetail () {
      if (this.isMember) {
        return true
      }

      return ecosystemMemberHasAccessToChallenge(this.challenge, this.userId, this.accessibleChallengeStatusses)
    },
    isCommunityManagerAndPortfolioManager (): boolean {
      return this.$store.state.communities.listData.data
        .filter((community: any) => {
          return community.communityManagerIds.includes(this.$store.getters.userId)
        }).length > 0
    },
  },
  methods: {
    hasClaimedActor (actorId: number): boolean {
      return this.profile.claimedIds.some((actor: any) => actor === actorId)
    },
  },
})
